import React from "react";
import { useSelector } from "react-redux";
import StarReview from "../common/StarReview";
import { formatDate } from "../helper/formatters";
import styles from "../../_css/Home.module.css";

const DEFAULT_IMAGE = `${process.env.PUBLIC_URL}/img/profile-image-default.jpg`;

function ReviewCard({ ratings, review, user_name, image_url, created_at }) {
  const lang = useSelector((state) => state.language.lang);
  const formattedDate = created_at ? formatDate(created_at) : null;

  return (
    <div className={styles.reviewCard}>
      <img
        src={image_url || DEFAULT_IMAGE}
        alt="profile"
        className={styles.reviewCardAvatar}
        onError={(e) => {
          e.target.src = DEFAULT_IMAGE;
        }}
      />
      <div className={styles.reviewCardBody}>
        <div className={styles.reviewCardMeta}>
          <span className={styles.reviewCardUserName}>{user_name}</span>
          {formattedDate && (
            <span className={styles.reviewCardDate}>{formattedDate}</span>
          )}
        </div>
        <div className={styles.reviewCardStars}>
          <StarReview
            rating={ratings}
            size={12}
            padding="1px"
            dir={lang === "ar" ? "rtl" : "ltr"}
          />
        </div>
        <p className={styles.reviewCardText}>{review}</p>
      </div>
    </div>
  );
}

export default ReviewCard;
